var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('LandingNav'),_c('v-container',{staticClass:"pdf-viewer",attrs:{"fluid":"","grid-list-md":"","pa-0":"","pt-3":"","mt-5":""}},[_c('div',{attrs:{"id":"pdf-holder"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }